
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/bestill-reiser",
      function () {
        return require("private-next-pages/[region]/[resort]/bestill-reiser.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/bestill-reiser"])
      });
    }
  